export enum SdkLoadingError {
  NotStartedLoading = "NotStartedLoading",
  Error = "Error",
}

export enum SdkLoadingState {
  Initial = "Initial",
  Loading = "Loading",
  Loaded = "Loaded",
  Initialized = "Initialized",
}
